export interface FeedbackQuestion {
    field: string;
    text: string;
    lowLabel: string;
    highLabel: string;
}

export const ORDER_QUESTIONS: FeedbackQuestion[] = [
    {
        field: 'score_overall',
        text: 'How satisfied are you with your overall experience working with The Desire Company?',
        lowLabel: 'Very dissatisfied',
        highLabel: 'Very satisfied',
    },
    {
        field: 'score_talent',
        text: 'How satisfied are you with the experts or talent selected for your project?',
        lowLabel: 'Very dissatisfied',
        highLabel: 'Very satisfied',
    },
    {
        field: 'score_communication',
        text: 'How would you rate the clarity and consistency of communication throughout the project?',
        lowLabel: 'Very poor',
        highLabel: 'Excellent',
    },
    {
        field: 'score_process',
        text: 'How would you rate the organization and ease of the overall project process?',
        lowLabel: 'Very poor',
        highLabel: 'Excellent',
    },
    {
        field: 'score_work_again',
        text: 'How likely are you to work with The Desire Company again?',
        lowLabel: 'Not at all likely',
        highLabel: 'Extremely likely',
    },
    {
        field: 'score_recommend',
        text: 'How likely are you to recommend The Desire Company to another brand or colleague?',
        lowLabel: 'Not at all likely',
        highLabel: 'Extremely likely',
    },
    {
        field: 'score_additional_opportunities',
        text: 'How interested would you be in exploring additional content opportunities with The Desire Company?',
        lowLabel: 'Not interested',
        highLabel: 'Very interested',
    },
];

export const PROJECT_QUESTIONS: FeedbackQuestion[] = [
    {
        field: 'score_content_quality',
        text: 'How satisfied are you with the quality of the final content?',
        lowLabel: 'Very dissatisfied',
        highLabel: 'Very satisfied',
    },
    {
        field: 'score_goal_alignment',
        text: 'How well did the final content align with your original goals?',
        lowLabel: 'Not at all',
        highLabel: 'Extremely well',
    },
    {
        field: 'score_messaging',
        text: 'How effectively did the content communicate your brand and product messaging?',
        lowLabel: 'Not at all effective',
        highLabel: 'Extremely effective',
    },
    {
        field: 'score_timeliness',
        text: 'How satisfied are you with the timeliness of project milestones and final delivery?',
        lowLabel: 'Very dissatisfied',
        highLabel: 'Very satisfied',
    },
    {
        field: 'score_expected_value',
        text: 'How valuable do you expect the content to be in supporting your marketing or retail media goals?',
        lowLabel: 'Not at all valuable',
        highLabel: 'Extremely valuable',
    },
];

export const SCORE_OPTIONS = [1, 2, 3, 4, 5];

export const CHANNEL_SCALE = {
    lowLabel: 'Very dissatisfied',
    highLabel: 'Very satisfied',
};

export const entityKey = (entityType: string, entityId: number): string =>
    `${entityType}:${entityId}`;
